import styled from "styled-components";

export const ControlLabelContainer = styled.div`
  position: relative;
  display: flex;
  padding: 0.4rem;
  background: ${({ theme }: {theme: any}) => theme.themePrimary};
  border-radius: 50%;

  > svg { 
    height: 1rem;
    width: 1rem;
    object-fit: contain;
    color: ${({ theme }: {theme: any}) => theme.themeLighter};
  }

  &:hover {
    background: ${({ theme }: {theme: any}) => theme.themeLight};

    .controlTooltip {
      visibility: visible;
      opacity: 1;
     }
  }

  .controlTooltip { 
    visibility: hidden;
    opacity: 0;
    position: absolute;
    padding-top: 0.5rem;
    top: calc(100% + 0.5rem);
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.3s ease;
  }
`